module.exports = __webpack_public_path__ + "static/media/logo.e40128f5.png";